<template>
  <div class="tabulka" :class="TableWidth">
    <div class="tabulka__top">
      <div class="tabulka__top__nadpis">Team info</div>
    </div>
    <div class="tabulka__body">
      <table>
        <thead>
          <td>
            <span>Name</span>
            <SortButton
              row="username"
              type="a"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
        </thead>
        <tr v-for="player in sortedData" :key="player.username">
          <td class="important">
            {{ player.username }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TeamInfo",
  mixins: [sortingLogicMixin],
  props: {
    TableWidth: String,
  },
  components: {
    SortButton,
  },
  data() {
    return {
      currentSortRow: "username",
    };
  },
  computed: {
    ...mapGetters({
      sourceData: "myTeamUsers",
    }),
  },
};
</script>
